Vendd.Scripts.load(function () {

    if ($('.homepage-slider > ul > li').length < 2)
        return;
    var hostname = window.location.hostname;
 
    function sliderHeight() {
        var $homeSlider = $('.homepage-slider');
        var sliderHeight = $(window).innerHeight();

        if ($(window).innerWidth() >= 768) {
            $homeSlider.css('height', sliderHeight);
            $homeSlider.find('img, video, iframe').css('height', sliderHeight);
        } else {
            $homeSlider.css('height', '');
            $homeSlider.find('img, video, iframe').css('height', '');
        }
    }
    const hpMainSlider = new Swiper(".home-page .homepage-slider", {
        // wrapper is <ul>, so keep slides as listitem rather than Swiper's default role="group" (WCAG 1.3.1)
        a11y: { slideRole: "listitem" },
        loop: true,
        slidesPerView: 1,
        autoHeight: false,
        rewind: false,
        fadeEffect: {
            crossFade: true
        },
        effect: 'fade',
        watchSlidesProgress: true,
        keyboard: { enabled: true },
        speed: 1500, 
        autoplay: {
            delay: 5000
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + $('.home-page .homepage-slider .swiper-slide').eq(index).attr("data-pager") + '</span>';
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            beforeInit: function () {
               // sliderHeight();
            },
            resize: function () {
               // sliderHeight();
            }

        }
    });

    hpMainSlider.on('slideChange', function () {
        var $currentSlide = $(".homepage-slider > ul > li[data-index='" + this.previousIndex + "']");
        var hasVideo = $('.video-slide', $currentSlide).length > 0;
        var videoInitialized = $('iframe', $currentSlide).length > 0;

        if (hasVideo && videoInitialized) {
            var YTvideo = YT.get($('iframe', $currentSlide).attr('id'));
            //pause video
            YTvideo.pauseVideo();
        }
    });
    function initScrollBanner() {
        var headerHeight = $('.header-region .region-area-two').innerHeight();
        $('.homepage-slider .scroll-to').click(function () {
            var sectionHeight = $('.home-region .region-area-three').outerHeight() - headerHeight;
            $('html, body').animate({ scrollTop: sectionHeight }, 'slow');
        });
    }
    initScrollBanner();
});
